import { render, staticRenderFns } from "./KohlerMilestoneRow.vue?vue&type=template&id=8f07fed2&"
import script from "./KohlerMilestoneRow.vue?vue&type=script&lang=js&"
export * from "./KohlerMilestoneRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports